// src/routes/projectsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Projects from '../pages/projects/Projects';
import CreateProject from '../pages/projects/CreateProject';
import EditProject from '../pages/projects/EditProject';
import ProtectedRoute from '../components/global/ProtectedRoute';

const projectsRoutes = (
    <>
        {/* Projects List */}
        <Route
            path="/projects"
            element={
                <ProtectedRoute requiredPermission="viewAny-project">
                    <Projects />
                </ProtectedRoute>
            }
        />

        {/* Create Project */}
        <Route
            path="/projects/create"
            element={
                <ProtectedRoute requiredPermission="create-project">
                    <CreateProject />
                </ProtectedRoute>
            }
        />

        {/* Edit Project */}
        <Route
            path="/projects/:id/edit"
            element={
                <ProtectedRoute requiredPermission="update-project">
                    <EditProject />
                </ProtectedRoute>
            }
        />
    </>
);

export default projectsRoutes;